export default "__VITE_ASSET__BlV1ki16__"